export class Mutex {
    constructor() {
        this.promise = Promise.resolve();
    }

    runExclusive(callback, ...args) {

        return (this.promise = this.promise.then(async () => {
            try {
                const ret = await callback(...args);
                // console.log(ret);
            } catch (e) {
                console.error(e);
            }
            return;
        }));
    }
}

export function resizeTextToFit(fittingText) {
    const container = fittingText.parentElement;
    const containerWidth = container.offsetWidth;
    const text = fittingText.textContent;
    let fontSize = 20; // Initial font size (you can adjust)

    fittingText.style.fontSize = `${fontSize}px`; // Apply initial size

    // Function to get the rendered width of the text
    function getTextWidth() {
        const temp = document.createElement('span');
        temp.style.visibility = 'hidden';
        temp.style.position = 'absolute';
        temp.style.whiteSpace = 'nowrap';
        temp.style.fontFamily = window.getComputedStyle(fittingText).fontFamily;
        temp.style.fontSize = `${fontSize}px`;
        temp.textContent = text;
        document.body.appendChild(temp);
        const width = temp.offsetWidth;
        document.body.removeChild(temp);
        return width;
    }

    let textWidth = getTextWidth();

    // Iteratively decrease font size if text is too wide
    while (textWidth > containerWidth && fontSize > 5) { // Set a minimum font size
        fontSize -= 1;
        fittingText.style.fontSize = `${fontSize}px`;
        textWidth = getTextWidth();
    }

    // Optional: Iteratively increase font size if there's significant space
    while (textWidth < containerWidth * 0.9 && fontSize < 100) { // Set a maximum font size and a threshold
        fontSize += 1;
        fittingText.style.fontSize = `${fontSize}px`;
        textWidth = getTextWidth();
    }
}

/**
 * Removes duplicate elements from an array, optionally using a comparison function.
 * @param {Array} arr The input array.
 * @param {function} [compareFn] An optional function to determine element uniqueness.
 * @returns {Array} A new array with unique elements.
 */
export function uniqueArray(arr, compareFn) {
    const seen = new Set();
    const uniqueArray = [];

    for (const element of arr) {
        if (element) { // Handles null/undefined elements
            const compareValue = compareFn ? compareFn(element) : element; // Use element itself if no compareFn
            if (!seen.has(compareValue)) {
                seen.add(compareValue);
                uniqueArray.push(element);
            }
        }
    }
    return uniqueArray;
}

/**
 * Creates a new array with unique elements based on a specific key in each object.
 * @param {Array<object>} array The input array of objects.
 * @param {string} key The key to use for determining uniqueness.
 * @returns {Array<object>} A new array with unique objects.
 */
export function unique(array, key) {
    const result = array.reduce((map, item) => {
        if (item && item[key] !== undefined) { // Check for null/undefined items and key values.
            map[item[key]] = item;
        }
        return map;
    }, {});
    return Object.values(result);
}

/**
 * Decodes HTML entities in a string using DOMParser.
 * @param {string} encodedString The string containing HTML entities.
 * @returns {string} The decoded string.
 */
export function decodeHTMLEntity(encodedString) {
    const parser = new DOMParser();
    const decodedString = parser.parseFromString(encodedString, 'text/html').body.textContent;
    return decodedString;
}

/**
 * Sanitizes a string by removing potentially malicious HTML, like script tags and event attributes.
 * @param {string} inputString The string to sanitize.
 * @returns {string} The sanitized string.
 */
export function sanitizeString(inputString) {
    let sanitizedString = inputString.replace(/<script[^>]*>.*?<\/script>/gi, '');
    sanitizedString = sanitizedString.replace(/<[^>]*\s(onload|onerror|onclick|on\w+)=/gi, '<');
    return sanitizedString;
}

/**
 * Asynchronously iterates over an array, executing a callback function for each element.
 * @param {Array} array The array to iterate over.
 * @param {function} callback The asynchronous callback function to execute for each element.
 * @returns {Promise<void>} A Promise that resolves when all iterations are complete.
 */
export async function asyncForEach(array, callback) {
    const promises = [];
    for (let index = 0; index < array.length; index++) {
        const promise = await callback(array[index], index, array);
        if (promise) {
            promise.catch((e) => {
                console.error(e);
            });
            promises.push(promise);
        }
    }
    await Promise.all(promises);
}